import React from 'react';
import { DollarSign, Clock, ChevronRight } from 'lucide-react';

const PaymentFlag = ({ payment, onClick }) => {
  const isPaid = payment?.status === 'paid';
  const paymentDate = payment?.date ? new Date(payment.date) : null;
  const formattedDate = paymentDate ? 
    `${paymentDate.toLocaleDateString('es-AR')} ${paymentDate.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}` : 
    null;

  const getPaymentMethodLabel = (method) => {
    switch (method) {
      case 'cash': return 'Efectivo';
      case 'transfer': return 'Transferencia';
      case 'credit': return 'Cuenta corriente';
      default: return method;
    }
  };

  return (
    <div 
      className={`bg-white dark:bg-gray-800 rounded-lg p-4 border dark:border-gray-700 ${!isPaid ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700' : ''}`}
      onClick={!isPaid && onClick ? onClick : undefined}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
            isPaid ? 'bg-green-100 dark:bg-green-900/50' : 'bg-amber-100 dark:bg-amber-900/50'
          }`}>
            <DollarSign className={`w-5 h-5 ${
              isPaid ? 'text-green-600 dark:text-green-400' : 'text-amber-600 dark:text-amber-400'
            }`} />
          </div>
          <div className="font-medium text-gray-900 dark:text-white">
            PAGO
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <div>
            <div className="text-right font-medium text-gray-900 dark:text-white">
              {isPaid ? 'Pagado' : 'Pendiente'}
            </div>
            {isPaid && payment.method && (
              <p className="text-sm text-gray-500 dark:text-gray-400 text-right">
                {getPaymentMethodLabel(payment.method)}
              </p>
            )}
          </div>
          {!isPaid && <ChevronRight className="w-5 h-5 text-gray-400" />}
        </div>
      </div>

      {isPaid && formattedDate && (
        <div className="ml-11 flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 mt-2">
          <Clock className="w-4 h-4" />
          {formattedDate}
        </div>
      )}
    </div>
  );
};

export default PaymentFlag; 